module.exports = __webpack_public_path__ + "img/nota-folio-tomason-industrial.bed9dd80.png";